import { memo } from "react";
import styles from "@/interface/RightSheet/Presentations/PresentationsNavigator/PresentationView/PresentationView.module.scss";

export const SlideIndex = memo(({ index }: { index: number }) => (
    <p className={styles.slideIndex}>{index + 1}</p>
));
